import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ConfirmDelete,
  MwButton,
  MwSpinner,
  MwSpinnerButton,
} from "../../components/ui";
import { useDelete, useFetch } from "../../hooks";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDelete } from "react-icons/md";

import { useTranslation } from "react-i18next";
import useConverter from "../../hooks/useConverter";
import { useSelector } from "react-redux";
import { NewButton } from "../../components/ui/NewButton";
import i18next from "i18next";
import { FaWindowClose } from "react-icons/fa";
export const IncomesShow = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const [onshow, setOnShow] = useState(false);
  const incomeId = params?.id;
  const hasValidIncomeId =
    Boolean(incomeId) && incomeId !== "null" && incomeId !== "undefined";
  const {
    data: incomeData,
    loading,
    error,
  } = useFetch(
    hasValidIncomeId
      ? `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/${incomeId}`
      : null
  );
  const { deleteItem, loading: delete_loading, data } = useDelete();
  const date = incomeData?.data?.incomes_date;
  const formattedDate = date
    ? new Date(date).toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    )
    : "";
  console.log(incomeData);

  useEffect(() => {
    if (!hasValidIncomeId) {
      navigate(`/${params.tenant}/incomes`, { replace: true });
    }
  }, [hasValidIncomeId, navigate, params.tenant]);

  const handlePrint = () => window.print();
  const managebonds = () => {
    navigate(`/${params.tenant}/incomes`);
  };
  const [showAttachPopup, setShowAttachPopup] = useState(false);
  const [load, setload] = useState(false);
  const handleDownloadPDF = () => {
    const input = document.getElementById("receipt-voucher");
    if (!input) {
      console.error("العنصر #receipt-voucher غير موجود!");
      return;
    }
    setload(true);

    html2canvas(input, {
      scale: 4,
      useCORS: true,
      logging: false,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pageWidth - 10;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const posX = (pageWidth - imgWidth) / 2;
        const posY = 10;

        pdf.addImage(imgData, "PNG", posX, posY, imgWidth, imgHeight);
        pdf.save(`Receipt_${incomeData?.data?.code || "Unknown"}.pdf`);
      })
      .catch((error) => console.error("خطأ في إنشاء الـ PDF:", error))
      .finally(() => setload(false));
  };
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  const { convertNumberToWords } = useConverter();
  const [totalAmountInWords, setTotalAmountInWords] = useState("");
  const language = useSelector((state) => state.lang.language);

  const totalAmount = incomeData?.data?.total_amount_with_vat || 0;
  const [riyal, halala] = String(totalAmount).split(".");

  if (loading) return <MwSpinner />;
  if (error)
    return (
      <p className="text-red-500">
        Failed to load data. Please try again later.
      </p>
    );

  return (
    <>
      <ConfirmDelete
        setOnShow={setOnShow}
        onShow={onshow}
        msg={t("Validate.confirm-del-bond")}
        onDeleteHandler={async () => {
          try {
            await deleteItem(
              `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/${params.id}`,
              navigate(`/${params.tenant}/incomes`)
            );
            setOnShow(false);
          } catch (error) {
            console.error("Error deleting item:", error);
          } finally {
          }
        }}
        loading={delete_loading}
      />
      <section className="bond w-full h-full flex flex-col items-center justify-center">
        {/* header */}
        <section className="header flex justify-between w-[97%] mx-auto items-center text-[#251658]">
          <div className="head mt-4  flex items-center justify-center gap-2">
            <img className="w-4" srcSet="/assets/icons/icons.png" alt="bond" />
            <h3 className="font-bold">
              {" "}
              {t("dropdown.showbond")} {incomeData?.data?.code}
            </h3>
          </div>
          <NewButton
            onClick={managebonds}
            type="main"
            classNameCustom="mt-4   "
          >
            <img
              className="w-5"
              src="/assets/icons/Vector(10).png"
              alt="manage icon"
            />
            <p className="text-[13px] ms-1">{t("dropdown.manage")}</p>
          </NewButton>
        </section>
        <hr className="my-4 w-[97%] mx-auto" />
        {/* bond-content */}
        <section className="Bond-content md:max-h-[100vh] h-[100%] w-[100%] ms-0 flex flex-col md:flex-row justify-between  overflow-y-auto">
          <div
            dir="rtl"
            id="receipt-voucher"
            className="bond-right   border border-gray-400 rounded-md md:min-h-[50vh] h-max p-4 md:p-5 print:px-6  flex flex-col gap-1 md:gap-4 justify-around items-center w-[85%] md:w-[75%]  mx-auto"
          >
            {/* title */}
            <div className="title text-[#251658] relative w-44 font-bold text-center">
              <h1>سند قبض</h1>
              <h1>Receipt Voucher</h1>
              <span className="w-full h-[2px] bg-gray-400 block bottom-[0px] my-1  right-0 rounded-lg"></span>
              {formattedDate}
            </div>
            {/* money */}
            <div className="money flex flex-col md:flex-row justify-between items-end w-full gap-4">
              <div className="money-right flex justify-between items-center gap-3 w-full md:w-auto">
                <div className="hallah w-full text-[#251658] font-semibold">
                  <p>هـ.H</p>
                  <span className="min-w-16 font-bold h-9 border border-[#8D82B6] rounded-md text-center flex justify-center items-center">
                    {halala || "00"} {/* عرض الهللة */}
                  </span>
                </div>
                <div className="RS w-full text-[#251658] font-semibold">
                  <p>ريال.SR</p>
                  <span className="min-w-32 font-bold h-9 border border-[#8D82B6] rounded-md text-center flex justify-center items-center">
                    {riyal} {/* عرض الريال */}
                  </span>
                </div>
              </div>
              <div className="money-left flex justify-between items-center gap-5 w-full md:w-auto">
                <div className="RS w-full text-[#251658]">
                  <span className="w-32 h-9 border border-[#8D82B6] rounded-md text-center flex justify-center font-bold items-center">
                    {incomeData?.data?.code}
                  </span>
                </div>
              </div>
            </div>
            {/* name */}
            <div className="info w-full flex flex-col md:flex-row justify-between items-center text-[#251658] gap-4">
              <p className="text-[#251658] font-semibold">
                استلمنا من السادة :
              </p>
              <span className="w-full md:w-[65%] h-9 border border-[#8D82B6] rounded-md text-center flex justify-center items-center">
                {incomeData?.data?.seller_name}
              </span>
              <p className="text-[#251658] font-semibold">: Received From</p>
            </div>
            {/* amount */}
            <div className="info w-full flex flex-col md:flex-row justify-between items-center text-[#251658] gap-4">
              <p className="text-[#251658] font-semibold">مبلغ وقدره :</p>
              <span className="w-full md:w-[65%] md:ms-5 min-h-10 py-1 border border-[#8D82B6] rounded-md text-center flex justify-center items-center">
                {convertNumberToWords(
                  incomeData?.data?.total_amount_with_vat,
                  "ar"
                )}{" "}
                <br />
                {convertNumberToWords(
                  incomeData?.data?.total_amount_with_vat,
                  "en"
                )}
              </span>
              <p className="text-[#251658] font-semibold">: The sum of </p>
            </div>
            {/* vat */}
            <div className="vat w-full flex justify-center items-center text-[#251658] font-bold bg-[#F2F0FC] py-1 rounded-md">
              <h1>الخزينة : نقدى</h1>
            </div>
            {/* for */}
            <div className="for w-full flex flex-col md:flex-row justify-between items-center text-[#251658] gap-4">
              <p className="text-[#251658] font-semibold">وذلك مقابل :</p>
              <span className="w-full md:w-[65%] md:me-11 font-semibold min-h-9 border border-[#8D82B6] rounded-md text-center flex justify-center items-center">
                {incomeData?.data?.desc}
              </span>
              <p className="text-[#251658] font-semibold">: for </p>
            </div>
            {/* mangement */}
            <div className="manage flex flex-col md:flex-row justify-evenly items-center w-full gap-4">
              <div className="received text-[#251658] border-b border-dashed border-gray-400 pb-4 text-center">
                <p>توقيع المستلم </p>
                <p>Recevied by</p>
              </div>
              <div className="manager text-[#251658] border-b border-dashed border-gray-400 pb-4 text-center">
                <p>المدير </p>
                <p>Manager</p>
              </div>
              <div className="Accountant text-[#251658] border-b border-dashed border-gray-400 pb-4 text-center">
                <p> المحاسب </p>
                <p>Accountant </p>
              </div>
            </div>
          </div>
          {/* Mangement */}
          <div className="management flex flex-col md:me-4 gap-2 w-[85%] mx-auto h-max md:w-[20%] p-4 md:p-0">
            <div className="controls flex flex-col md:flex-row items-center justify-between gap-2 w-full">
              <NewButton
                type=""
                onClick={handlePrint}
                classNameCustom="w-[48%]"
              >
                <img
                  className="w-6"
                  srcSet="/assets/icons/Print.png"
                  alt="print icon"
                />
                <p className="text-[13px] ms-1">{t("dropdown.print")}</p>
              </NewButton>
              <NewButton classNameCustom="w-[48%]" onClick={handleDownloadPDF}>
                {load ? (
                  <MwSpinnerButton label={""} isFullCenter={true} />
                ) : (
                  <>
                    <img
                      className="w-4"
                      srcSet="/assets/icons/Vector.png"
                      alt="download icon"
                    />
                    <p className="text-[13px] ms-1">{t("dropdown.downLoad")}</p>
                  </>
                )}
              </NewButton>
            </div>
            <div className="cont flex justify-between items-center">
              <NewButton
                classNameCustom="w-[48%]"
                onClick={() =>
                  navigate(
                    `/${params.tenant}/incomes/edit/${incomeData?.data.id}`
                  )
                }
              >
                <img
                  className="w-5"
                  srcSet="/assets/icons/circum_edit.png"
                  alt="edit icon"
                />
                <p className="text-[13px] ms-1">{t("dropdown.edit")}</p>
              </NewButton>
              <NewButton
                classNameCustom="w-[48%]"
                onClick={() => setOnShow(true)}
              >
                <MdDelete className="text-lg" />

                <p className="text-[13px] ms-1">{t("dropdown.delete")}</p>
              </NewButton>
            </div>

            {incomeData?.data?.attach ? (
              <div className="flex flex-wrap justify-start gap-3 mt-3">
                {incomeData.data.attach.split(",").map((file, index) => {
                  const trimmedFile = file.trim();
                  const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(trimmedFile);

                  return (
                    <div
                      key={index}
                      onClick={() => {
                        setShowAttachPopup(true);
                        setSelectedAttachment(trimmedFile);
                      }}
                      className="relative cursor-pointer w-24 h-24 border border-[#8D82B6] rounded-md overflow-hidden flex items-center justify-center bg-gray-50 shadow-sm hover:shadow-md hover:scale-105 transition-all"
                    >
                      {isImage ? (
                        <img
                          src={trimmedFile}
                          alt={`attachment-${index}`}
                          className="object-cover w-full h-full"
                        />
                      ) : (
                        <div className="flex flex-col items-center justify-center gap-1 w-full h-full bg-white">
                          <iframe
                            src={trimmedFile}
                            title={`attach-pdf-${index}`}
                            className="w-[80%] h-[60%] border-none pointer-events-none"
                          />
                          <p className="text-[10px] text-[#261759] font-semibold">PDF</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-gray-500 text-center mt-20">{t("Validate.file")}</p>
            )}

          </div>
                {showAttachPopup && selectedAttachment && (
         <div
           className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 transition-opacity duration-300"
           onClick={() => setShowAttachPopup(false)}
         >
           <div
             className="relative bg-white rounded-2xl shadow-2xl max-w-[70vw] max-h-[85vh] w-full overflow-hidden animate-fadeIn"
             onClick={(e) => e.stopPropagation()}
           >
             {/* زر الإغلاق */}
             <button
               onClick={() => setShowAttachPopup(false)}
               className="absolute top-3 right-3 text-gray-600 hover:text-[#261759] transition-colors duration-200"
             >
               <FaWindowClose className="text-3xl" />
             </button>
       
             {/* المحتوى */}
             <div className="p-5 flex items-center justify-center max-h-[80vh] overflow-auto">
               {/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(selectedAttachment) ? (
                 <img
                   src={selectedAttachment}
                   alt="Enlarged Attachment"
                   className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-md"
                 />
               ) : (
                 <iframe
                   src={selectedAttachment}
                   title="Attachment PDF"
                   className="w-[90%] h-[70vh] border-none rounded-lg shadow-md"
                 />
               )}
             </div>
           </div>
         </div>
       )}
       

        </section>
      </section>
    </>
  );
};
